/* KNM-136 (folio): платежи по брони — приход (Поступление) и расход (Возврат). */
export const PAYMENT_DIRECTION_PAYMENT = 1
export const PAYMENT_DIRECTION_REFUND = -1

export const PAYMENT_TYPE_CASH = 1
export const PAYMENT_TYPE_CARD = 2
export const PAYMENT_TYPE_ACCOUNT = 3

// Порядок в селекте: перевод на карту (по умолчанию), расчётный счёт, наличные.
export const PAYMENT_TYPE_VALUES = [
  { value: PAYMENT_TYPE_CARD, label: 'Перевод на карту' },
  { value: PAYMENT_TYPE_ACCOUNT, label: 'Расчётный счёт' },
  { value: PAYMENT_TYPE_CASH, label: 'Наличные' },
]

export type ReservationPayment = {
  pk: number
  reservation_id: number
  payment_amount: string
  payment_type: number
  payment_type_verbose: string
  payment_direction: number
  payment_direction_verbose: string
  comment: string | null
  payment_date: string
}

export type CreatePaymentReq = {
  payment_amount: number
  payment_type: number
  payment_direction: number
  payment_date: string
  comment: string
}

export const PAYMENTS_URL = '/v2/pms/reservations/:reservation_pk/payments/'
